import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import indexFirst from '@/components/indexFirst'
import about from '@/components/about'
import download from '@/components/download'
import join from '@/components/join'
import contact from '@/components/contact'
import server from '@/components/server_bd'
import pilotProgram from '@/components/pilotProgram'

import openPlantfromWap from '@/components/openPlatform/openPlantfromWap'
import indexTwo from '@/components/openPlatform/indexTwo'
import wap from '@/components/wap'

Vue.use(Router)
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

export default new Router({
  mode: 'history',
  routes: [
    {
      // 首页
      path: '/',
      name: 'vue',
      component: wap,
      children: [
        {
          path: '/',
          name: 'indexFirst',
          component: indexFirst
        },
        {
          path: '/about',
          name: 'about',
          component: about
        },
        {
          path: '/download',
          name: 'download',
          component: download
        },
        {
          path: '/join',
          name: 'join',
          component: join
        },
        {
          path: '/contact',
          name: 'contact',
          component: contact
        },
        {
          path: '/server',
          name: 'server',
          component: server
        },
        {
          path: '/pilotProgram',
          name: 'pilotProgram',
          component: pilotProgram
        },
      ]
    },
    {
      // 开放平台
      path: '/openPlantfrom',
      name: 'openPlantfrom',
      component: openPlantfromWap,
      children: [
        {
          path: '/indexTwo',
          name: 'indexTwo',
          component: indexTwo
        },
      ]
    },
    {
      path: '*',
      redirect: '/'
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js